import { Grid } from '@mui/material';
import * as React from 'react';

const PanelAcademicoView = () => {
  return <Grid container></Grid>;
};

export default PanelAcademicoView;
